import React, { useState } from "react";

const ReportingView = () => {
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      {loading && (
        <div
          style={{
            width: "100%",
            height: "90vh",
            zIndex: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
          }}
        >
          <img
            alt="loading"
            width="60"
            height="60"
            src={require("static/img/Theme-loader.gif")}
          />
        </div>
      )}
      <iframe
        src="https://lookerstudio.google.com/embed/u/2/reporting/cac34c52-f461-48fd-921a-07a7c659a257/page/p_w886m40p8c"
        frameborder="0"
        style={{ border: 0, width: "100%", height: "90vh" }}
        title="Reporting View"
        allowfullscreen
        onLoad={handleIframeLoad}
        sandbox="allow-storage-access-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      ></iframe>
    </div>
  );
};

export default ReportingView;
